import {Constant} from "./index";
import {STATE} from "../../Type";
import {Block} from "../index";

export class Position extends Constant {
  get type() {
    return "Position";
  }

  get category() {
    return "Constant";
  }

  isEqual(block) {
    if (!(block instanceof Block)) {
      return false;
    }

    return (
      this.type === block.type &&
      this.data.x === block.data.x &&
      this.data.y === block.data.y &&
      this.data.z === block.data.z
    );
  }

  static getPrototypeBlocks() {
    return [new Position({data: {x: 0, y: 0, z: 0}, state: STATE.PROTOTYPE})];
  }
}
